import { Empresa } from './empresa';

export class LogPedido  {
    public Id: number;    
    public Empresa: Empresa;
    public NumPedido: number;    
    public Status: string; 
    public Obs: string; 
    public PrimeiraCartela: string; 
    public SegundaCartela: string; 
}


// WEBPACK FOOTER //
// ./src/entities/logPedido.ts